export class TypographyUtils {
  /**
   * Check the text for an innerHTML, add <p> tag if missing
   */
  static getHTMLText(str: string): string {
    if (!str) {
      return '';
    }

    if (str?.startsWith('<p>')) {
      return str;
    } else {
      return '<p>' + str + '</p>';
    }
  }

  static removeHTMLTags(str: string): string {
    if (str === null || str === '') {
      return '';
    } else {
      return str.replace(/<[^>]*>/g, '');
    }
  }

  static isEmptyObject(content) {
    return (
      (content && Object.keys(content).length === 0) ||
      (content
        ? Object.keys(content).length
          ? Object.keys(content)
            .filter((property: string) => {
              return property !== 'type';
            })
            .every((key) => {
              return (
                content[key] === null ||
                  content[key] === undefined ||
                  content[key] === ''
              );
            })
          : false
        : false) ||
      !content
    );
  }

  static truncateHTMLContent(html: string, limit: number): { preview: string, remaining: string } {
    const parser = new DOMParser();
    const doc = parser.parseFromString(html, 'text/html');
    const body = doc.body;

    let charCount = 0;
    let reachedLimit = false;

    const resultPreview = document.createElement('div');
    const resultRemaining = document.createElement('div');

    const walkNodes = (sourceNode: Node, targetPreview: Node, targetRemainder: Node) => {
      for (const child of Array.from(sourceNode.childNodes)) {
        if (reachedLimit) {
          targetRemainder.appendChild(child.cloneNode(true));
          continue;
        }

        if (child.nodeType === Node.TEXT_NODE) {
          const text = child.textContent || '';
          const words = text.split(/(\s+)/); // keep spaces

          const previewTextParts: string[] = [];
          const remainderTextParts: string[] = [];

          for (const word of words) {
            if (charCount + word.length <= limit && !reachedLimit) {
              previewTextParts.push(word);
              charCount += word.length;
            } else {
              reachedLimit = true;
              remainderTextParts.push(word);
            }
          }

          if (previewTextParts.join('').trim()) {
            targetPreview.appendChild(document.createTextNode(previewTextParts.join('')));
          }
          if (remainderTextParts.join('').trim()) {
            targetRemainder.appendChild(document.createTextNode(remainderTextParts.join('')));
          }

        } else if (child.nodeType === Node.ELEMENT_NODE) {
          const clonedForPreview = child.cloneNode(false);
          const clonedForRemainder = child.cloneNode(false);

          targetPreview.appendChild(clonedForPreview);
          targetRemainder.appendChild(clonedForRemainder);

          walkNodes(child, clonedForPreview, clonedForRemainder);
        }
      }
    };

    walkNodes(body, resultPreview, resultRemaining);

    return {
      preview: resultPreview.textContent?.trim() ? resultPreview.innerHTML : '',
      remaining: resultRemaining.textContent?.trim() ? resultRemaining.innerHTML : ''
    };
  }
}
